// Run after Turbolinks swaps in the new DOM for this page
document.addEventListener("turbolinks:load", function () {
    initializeSort();
    initializeCollapseToggle();
    initializeDragHoverBehavior();
    // Grab the search input and the results container
    const input = document.getElementById("assignments-live-search");
    if (input === null) return;
    const $assignmentsAndFolders = $("#assignments-and-folders");
    if (!input) return; // If the input isn't on this page, stop

    // One-time bind guard (persists even if multiple jQuery copies exist)
    if (input.dataset.liveSearchBound === "1") return;
    input.dataset.liveSearchBound = "1";

    // jQuery-wrapped input for convenience
    const $input = $(input);

    // Timer for debounce, and a handle to the current AJAX request
    let timer = null;
    let currentRequest = null;

    // Track in-flight queries and last-started query for dedupe
    //   - inFlightByQuery prevents issuing the same query while it’s already pending
    //   - lastStartedQuery prevents immediate back-to-back duplicates
    const inFlightByQuery = new Map();
    let lastStartedQuery = null;

    // Actually perform the live search
    function execute_live_search(search_value = null) {
        const searchValue = search_value !== null ? search_value : $input.val();
        const searchIsInvalid = searchValue.length < 2 && searchValue.length > 0
        let filterValue = $(".bulk_edit_bar__content-filter-item-active").attr("data-pill-text");
        if (filterValue == null) {
            filterValue = "default"
        }

        // Ignore 1-character (non-empty) terms to reduce noise;
        // allow empty string (usually means "show all")
        if (searchIsInvalid && filterValue === "default") return;

        // If the exact same query is already in flight, skip
        if (searchIsInvalid && inFlightByQuery.get(searchValue) === true) return;

        // If we just started this exact query, skip (extra safety)
        if (searchIsInvalid && lastStartedQuery === searchValue) return;
        lastStartedQuery = searchValue;

        // If there’s a different pending request, abort it (latest input wins)
        if (currentRequest && currentRequest.readyState !== 4) {
            currentRequest.abort();
        }

        // Pull the first number from the URL as the course ID
        const courseID = (window.location.pathname.match(/\d+/) || [])[0];
        // Build the endpoint for deep-linking search
        const deepLinkingPath = `/courses/${courseID}/assignments/deep_linking_live_search`;

        // Mark this query as active
        inFlightByQuery.set(searchValue, true);

        // Fire the request; expect JSON with an `html` key
        currentRequest = $.ajax({
            type: "GET",
            dataType: "json",
            url: deepLinkingPath,
            data: { search_value: searchValue,
                    filter_value: filterValue,
                    type: "assignments"
            },

            // Update the results area on success
            success: function (data) {
                if (data.html) {
                    // Replace the container’s HTML
                    $assignmentsAndFolders.html(data.html);
                    initializeCollapseToggle()
                    syncCheckboxStates()
                    $('.info_button_assignment_li').popover()

                    // Re-init animations on newly injected DOM (if available)
                    // window.initAssignmentAnimations?.($assignmentsAndFolders[0]);
                    if (searchValue.length > 0 || filterValue !== "default") {
                        $('.collapse').collapse('show');
                    }

                    if (searchValue.length === 0 && filterValue === "default")
                        initializeSort();
                } else {
                    // Friendly empty state if nothing matched
                    $assignmentsAndFolders.html("<p>No items match your search.</p>");
                }
            },

            // Always clear tracking when the request finishes (success or error)
            complete: function () {
                inFlightByQuery.delete(searchValue);
                currentRequest = null;
            }
        });
    }

    // Debounce: wait 500 ms after the user stops typing before searching
    function debounce() {
        if (timer) clearTimeout(timer);
        timer = setTimeout(execute_live_search, 500);
    }

    $("#bulk_edit_bar__content-search-close").on("click", function() {
        if ($input.val().length === 0) return;
        $input.val("");
        execute_live_search("");
    });


    // Listen to `input` (captures typing, paste, autofill). Namespaced for clean unbinds.
    $input
        .off("input.liveSearch keyup.liveSearch") // avoid duplicate bindings after navigations
        .on("input.liveSearch", debounce);

    // Before Turbolinks snapshots the DOM, clean everything up
    document.addEventListener("turbolinks:before-cache", function () {
        // Remove handlers
        $input.off("input.liveSearch keyup.liveSearch");
        $("#bulk_edit_bar__content-search-close").off("click");
        // Clear a one-time bind flag so it can rebind on the next load
        input.dataset.liveSearchBound = "";
        // Abort any in-flight request (prevents updating a cached DOM)
        if (currentRequest && currentRequest.readyState !== 4) currentRequest.abort();
        // Reset dedupe state
        inFlightByQuery.clear();

        $(document).off('mouseenter.dragHover').off('mouseleave.dragHover');
        window.isDragging = false;
    });

    window.execute_live_search = execute_live_search;
});

const syncCheckboxStates = () => {
    window.selectedAssignmentIds.forEach(id => {

    });
    updateHiddenInputs()
    bulkEditActive(window.selectedAssignmentIds.size > 0, event);
}

const updateHiddenInputs = () => {
    const $form = $("#bulk-edit-form");
    $form.find(".persisted-assignment").remove();
    window.selectedAssignmentIds.forEach(assignment_id => {
        const currentCheckbox = $(`.bulk-edit-checkbox[value="${assignment_id}"]`)
        currentCheckbox.prop("checked", true);
        if (currentCheckbox.length === 0) {
            $form.append(`<input type="hidden" name="assignment_ids[]" value="${assignment_id}" class="persisted-assignment">`);
        }
        updateParentCheckbox(assignment_id)
    });
};

const updateParentCheckbox = (assignment_id) => {
    const currentParent = $(`#Assignment_${assignment_id}`).closest(".assignment-group").find(".bulk-edit-checkbox-parent");
    const groupId = currentParent.attr("data-group");
    const allChildrenCheckboxes = $(".bulk-edit-child-checkbox[data-group='" + groupId + "']").length
    const allCheckedChildrenCheckboxes = $(".bulk-edit-child-checkbox[data-group='" + groupId + "']:checked").length
    const propType = allChildrenCheckboxes === allCheckedChildrenCheckboxes ? "checked" : "indeterminate"
    currentParent.prop(propType, true);
};

// Utility functions for managing empty cards
function addEmptyCard($folderList) {
    if (!document.getElementById("assignment_resource")) return;

    // Check if there's already an empty card
    if ($folderList.find('li[style*="pointer-events: none"]').length === 0) {
        const emptyCardHtml = '<li class="assignment_resource__main_panel__form__resources__card text-secondary" style="pointer-events: none;">There are no assignments in this folder</li>';
        $folderList.append(emptyCardHtml);
    }
}

function removeEmptyCard($folderList) {
    $folderList.find('li[style*="pointer-events: none"]').remove();
}

function hasRealResources($folderList) {
    // Ignore empty-state and pagination rows when checking for real resources.
    return $folderList.children('li')
        .not('[style*="pointer-events: none"]')
        .not('.sortable-ignore')
        .length > 0;
}

// Function to update the assignment counter in folder header
function updateFolderCounter($folderList) {
    // Count real resources (not empty cards)
    const resourceCount = $folderList.children('li')
        .not('[style*="pointer-events: none"]')
        .not('.sortable-ignore')
        .length;

    // Find the folder's counter element
    const $folderWrapper = $folderList.closest('.assignment-group-wrapper');
    const $counterElement = $folderWrapper.find('.assignment-group-wrapper-information .assignment_resource__main_panel__form__resources__card__primary-information-description-activity_list');

    if ($counterElement.length) {
        let counterText;
        if (resourceCount === 0) {
            counterText = "No assignments";
        } else if (resourceCount === 1) {
            counterText = "1 assignment";
        } else {
            counterText = `${resourceCount} assignments`;
        }

        $counterElement.text(counterText);
    }
}

function handleValidResourceMove(event, ui) {
    if (ui.item.data("cancel")) {
        $(this).sortable("cancel");
        ui.item.data("cancel", null);
        return;
    }

    // Only process if this is the actual target container
    if (event.target !== this) {
        return;
    }

    const $targetFolder = $(this);
    const $sourceFolder = ui.sender;

    // Remove empty card from target folder if it now has real resources
    if (hasRealResources($targetFolder)) {
        removeEmptyCard($targetFolder);
    }
    // Add empty card to source folder if it no longer has real resources
    if ($sourceFolder && !hasRealResources($sourceFolder)) {
        addEmptyCard($sourceFolder);
    }
    // Update counters for both folders
    updateFolderCounter($targetFolder);
    if ($sourceFolder) {
        updateFolderCounter($sourceFolder);
    }

    $.ajaxQueue({
        type: "POST",
        url: $(this).data("groupchange-url"),
        data: {
            assignment: ui.item.attr("id").split('_')[1],
            membership_id: ui.item.attr("id").split('_')[1],
            target_group_id: $(this).data("target-group-id")
        },
        success: function(data) {
            if (data.success) {
                // Update the moved item's data-group attributes and all children with data-group
                ui.item.attr("data-group", `AssignmentResourceGroup_${data.target_group_id}`);
                ui.item.find("[data-group]").attr("data-group", `AssignmentResourceGroup_${data.target_group_id}`);

                updateGroupCheckboxesAfterMove(data);

                // Refresh checkbox associations
                if (window.refreshCheckboxAssociations) {
                    window.refreshCheckboxAssociations();
                }

                updateFolderActionMenus(data);
                updateFolderDeleteModalTargets(data);
            }
        }
    });
}

function updateFolderDeleteModalTarget(resourceGroupId, hasGradedDeployments, lmsName) {
    if (!resourceGroupId) {
        return;
    }

    const targetSelector = hasGradedDeployments
        ? "#delete_resource_group_grades_warning_modal"
        : "#delete_resource_group_modal";

    $(`.assignment-resource-delete-folder-link[data-resource-group-id="${resourceGroupId}"]`)
        .attr("data-bs-target", targetSelector)
        .attr("data-has-graded-deployments", hasGradedDeployments)
        .attr("data-lms-name", lmsName || "");
}

function updateFolderDeleteModalTargets(data) {
    updateFolderDeleteModalTarget(data.target_group_id, data.target_group_has_graded_deployments, data.target_group_lms_name);
    updateFolderDeleteModalTarget(data.original_group_id, data.original_group_has_graded_deployments, data.original_group_lms_name);
}

function updateFolderActionMenu(resourceGroupId, actionsHtml) {
    if (!resourceGroupId || actionsHtml === undefined) {
        return;
    }

    const $groupContainer = $(`.assignment-group-wrapper > .assignment_resource__main_panel__form__resources__card[data-checkbox-id="group-checkbox-${resourceGroupId}"]`);
    const $actionsContainer = $groupContainer.find('> .assignment_resource__main_panel__form__resources__card__actions');

    if ($actionsContainer.length) {
        $actionsContainer.replaceWith(actionsHtml);
    }
}

function updateFolderActionMenus(data) {
    updateFolderActionMenu(data.target_group_id, data.target_group_actions_html);
    updateFolderActionMenu(data.original_group_id, data.original_group_actions_html);

    if (window.bindAddToLinksButtons) {
        window.bindAddToLinksButtons();
    }
}


window.initializeSort = function initializeSort() {
    $('.assignment-group').off('mouseenter').off('mouseleave');

    $(".assignment-sortable").vbSortable({
        items: "> *:not(.sortable-ignore)",
        placeholder: "sortable-placeholder list-group-item"
    })

    const $linkedSortables = $(".assignment-sortable.linked-sortable")
    $linkedSortables.sortable("option", "connectWith", ".assignment-sortable.linked-sortable")
    $linkedSortables.off('.assignmentResourceSort')

    // Add invisible padding to the bottom of sortable lists when dragging starts
    $linkedSortables.on("sortstart.assignmentResourceSort", function(event, ui) {
        // Add padding to all sortable lists to create larger drop zones
        $(".assignment-sortable.linked-sortable").each(function() {
            $(this).css({
                'padding-bottom': '50px',
                'min-height': '60px'
            });
        });
    });

    $linkedSortables.on("sortstop.assignmentResourceSort", function(event, ui){
        $(".assignment-sortable.linked-sortable").css({
            'padding-bottom': '',
            'min-height': ''
        });

        if  (ui.item.data("cancel")) {
            $(this).sortable("cancel")
            ui.item.data("cancel", null)
        }
    })


    $linkedSortables.on("sortreceive.assignmentResourceSort", function (event, ui){
        const isFolder = ui.item.hasClass('assignment-group-wrapper');
        const isNestedSortable = $(this).hasClass('linked-sortable');
        const isFolderInFolder = isFolder && isNestedSortable;

        if (isFolderInFolder) {
            // Show user some feedback (temporary)
            alert("Folders cannot be placed inside other folders.");
            // Cancel the operation - this should revert automatically
            $(this).sortable("cancel");
            if (ui.sender) {
                ui.sender.sortable("cancel");
            }
            return false;
        }

        // If it's a valid resource move, handle the business logic
        if (!isFolder && isNestedSortable) {
            handleValidResourceMove.call(this, event, ui);
        }
    })

    $(".assignment-sortable .list-group-folder > .list-group-inner").droppable({
        drop: function(event, ui) {
            // Check if this is a folder being dropped on a folder
            const isDroppingFolder = ui.draggable.hasClass('assignment-group-wrapper');

            if (isDroppingFolder) {
                alert("Folders cannot be placed inside other folders.");
                return false;
            }

            ui.draggable.data("cancel", true)

            // Find the target folder list
            const $targetFolder = $(this).parent().find(".assignment-sortable.linked-sortable");

            // Remove the empty card from the target folder since we're adding a resource
            removeEmptyCard($targetFolder);

            // Find the source folder (where the item came from)
            const $draggedItem = ui.draggable;
            const $sourceFolder = $draggedItem.parent();

            // Add an empty card to the source folder if it will be empty after this move
            // We need to check if there will be other resources left after removing this one
            const remainingResources = $sourceFolder.children('li').not('[style*="pointer-events: none"]').not($draggedItem).length;
            if (remainingResources === 0) {
                addEmptyCard($sourceFolder);
            }

            // Update counters for both folders
            // For target folder, we need to account for the item being added
            setTimeout(() => {
                updateFolderCounter($targetFolder);
                updateFolderCounter($sourceFolder);
            }, 250); // Small delay to let DOM update


            $.ajaxQueue({
                type: "POST",
                url: $(this).parent().find(".assignment-sortable.linked-sortable").data("groupchange-url"),
                data: {
                    assignment: ui.draggable.attr("id").split('_')[1],
                    membership_id: ui.draggable.attr("id").split('_')[1],
                    target_group_id: $(this).parent().find(".assignment-sortable.linked-sortable").data("target-group-id"),
                    manual_update: true
                },
                success: function(data) {
                    if (data.success) {
                        ui.draggable.attr("data-group", `AssignmentResourceGroup_${data.target_group_id}`);
                        ui.draggable.find("[data-group]").attr("data-group", `AssignmentResourceGroup_${data.target_group_id}`);
                        updateGroupCheckboxesAfterMove(data);

                        if (window.refreshCheckboxAssociations) {
                            window.refreshCheckboxAssociations();
                        }

                        updateFolderActionMenus(data);
                        updateFolderDeleteModalTargets(data);
                    }
                }
            })
        }
    })
};

function initializeDragHoverBehavior() {
    // Remove ALL possible event handlers
    $(document).off('mouseenter.dragHover').off('mouseleave.dragHover');

    let timer;

    // Use event delegation to handle dynamically added elements
    $(document).on('mouseenter.dragHover', '.assignment-group', function() {

            // Only proceed if we're currently dragging
            if (!window.isDragging) return;

            const $assignmentGroup = $(this);
            let target = $assignmentGroup.find('[data-bs-toggle="collapse"]').attr('aria-controls');

            if (target) {
                let $collapseTarget;
                timer = setTimeout(function(){
                    // This targets the correct element based on what page we are on
                    $collapseTarget = document.getElementById("assignment_resource") ? $(`#${target}`) : $(target);
                    // Only open if it's currently closed
                    if (!$collapseTarget.hasClass('show')) {
                        $collapseTarget.collapse('show');
                        $(".assignment-sortable").sortable("refresh");

                        // Extract resource group ID from the target ID (format: resourceGroupCollapse-{id})
                        const resourceGroupId = target.replace('resourceGroupCollapse-', '');

                        // Update the server-side state to track that this folder is now open
                        if (resourceGroupId && window.toggleResourceGroupState) {
                            window.toggleResourceGroupState(resourceGroupId);
                        }

                        // Update the aria-expanded attribute on the button
                        const $button = $assignmentGroup.find('[data-bs-toggle="collapse"]');
                        $button.attr('aria-expanded', 'true');
                    }
                }, 500);
            }
        }).on('mouseleave.dragHover', '.assignment-group', function() {
        // Only clear timer if we're dragging
        if (window.isDragging && timer) {
            clearTimeout(timer);
        }
    });
}

function updateGroupCheckbox(groupId, empty) {
    const groupContainer = $(`.assignment-group-wrapper > .assignment_resource__main_panel__form__resources__card[data-checkbox-id="group-checkbox-${groupId}"]`);

    if (groupContainer.length > 0) {
        const existingCheckbox = groupContainer.find('.assignment_resource__main_panel__form__resources__card__primary-checkbox');

        if (existingCheckbox.length === 1) {
            const groupNameElement = groupContainer.find(
                '.assignment_resource__main_panel__form__resources__card__primary-information-description-name.assignment-group'
            );
            const groupName = groupNameElement.length > 0 ? groupNameElement.text().trim() : '';
            const checkboxElement = createGroupCheckboxElement(groupId, groupName, empty);

            existingCheckbox.get(0).replaceWith(checkboxElement);
        }
    }
}

function createGroupCheckboxElement(groupId, groupName = '', empty) {
    const wrapper = document.createElement('div');
    wrapper.className = 'assignment_resource__main_panel__form__resources__card__primary-checkbox assignment-resource-row__checkbox';

    if (empty) {
        const spacer = document.createElement('span');
        spacer.className = 'assignment-resource-checkbox-spacer';
        spacer.setAttribute('aria-hidden', 'true');
        wrapper.appendChild(spacer);
        return wrapper;
    }

    const checkboxId = `group-checkbox-${groupId}`;
    const input = document.createElement('input');
    input.id = checkboxId;
    input.type = 'checkbox';
    input.name = 'assignment_resource_ids[]';
    input.className = 'assignment-resource-checkbox assignment-resource-checkbox-input assignment-resource-row__checkbox-input group-check';
    input.dataset.group = `AssignmentResourceGroup_${groupId}`;
    input.dataset.resourceGroupId = groupId;

    const label = document.createElement('label');
    label.htmlFor = checkboxId;
    label.className = 'visually-hidden';
    label.textContent = `Select ${groupName}`;

    wrapper.append(input, label);
    return wrapper;
}

function updateGroupCheckboxesAfterMove(data) {
    if (data.original_group_id && data.original_group_resource_count === 0) {
        updateGroupCheckbox(data.original_group_id, true);
    }

    if (data.target_group_id && data.target_group_resource_count === 1) {
        updateGroupCheckbox(data.target_group_id, false);
    }
}


const initializeCollapseToggle = function () {
    $("a.alt-img-link").each(function () {
        const elem = this;
        const targetSelector = $(elem).attr("href");

        $(targetSelector).on("show.bs.collapse", function () {
            toggleAltImg(elem);
        });

        $(targetSelector).on("hide.bs.collapse", function () {
            toggleAltImg(elem);
        });
    });


    $(".list-group-folder .collapse.start-open").collapse('show')
};
